import { downloadFile, formatDate, formatNumber } from '../../../core/helpers';
import { ReactComponent as DownloadIcon } from '../../../icons/download.svg';
import { ReactComponent as SendIcon } from '../../../icons/sent.svg';
import { ReactComponent as TipIcon } from '../../../icons/tip.svg';
import { useTranslation } from 'react-i18next';
import { DatevItem } from './TaxAdvisorDatev';
import { useTaxAdvisor } from '../tax-advisor-context';
import Button from '../../../components/Button';

interface Props {
  item: DatevItem;
  className?: string;
}

export default function TaxAdvisorDatevItem({
  item: { month, local_transactions, shipment, commingling, oss, sent },
  className = '',
}: Props) {
  const { company } = useTaxAdvisor();
  const { t } = useTranslation();
  return (
    <div className={`pb-4 mb-2 pt-2 ${className}`}>
      <div className='row mb-2'>
        <div className='col-8 fw-600'>{formatDate(month, 'MMMM')}</div>
        <div className='col'>{t('Transactions')}</div>
        <div className='col text-end'>{t('Gross amount')}</div>
      </div>
      <div className='row mb-2'>
        <div className='col-8'>{t('Local transactions')}</div>
        <div className='col'>{formatNumber(local_transactions.items)}</div>
        <div className='col text-end'>
          {formatNumber(local_transactions.amount / 100, {
            currency: 'eur',
          })}
        </div>
      </div>
      <div className='row mb-2'>
        <div className='col-8'>{t('Shipment')}</div>
        <div className='col'>{formatNumber(shipment.items)}</div>
        <div className='col text-end'>
          {formatNumber(shipment.amount / 100, {
            currency: 'eur',
          })}
        </div>
      </div>
      <div className='row mb-2'>
        <div className='col-8'>{t('Commingling')}</div>
        <div className='col'>{formatNumber(commingling.items)}</div>
        <div className='col text-end'>
          {formatNumber(commingling.amount / 100, {
            currency: 'eur',
          })}
        </div>
      </div>
      <div className='row mb-2'>
        <div className='col-8'>OSS</div>
        <div className='col'>{formatNumber(oss.items)}</div>
        <div className='col text-end'>
          {formatNumber(oss.amount / 100, {
            currency: 'eur',
          })}
        </div>
      </div>
      <div className='pt-2'>
        <div className='row row-cols-auto gx-2'>
          <div className='col'>
            <Button
              styling='outline'
              className='TaxAdvisorDatev__btn d-flex align-items-center'
              onClick={() => {
                downloadFile(
                  '/datev/datev.zip',
                  `${
                    company?.name ? `${company.name.split(' ').join('_')}-` : ''
                  }${formatDate(month, 'MMM-yyyy')}-datev.zip`
                );
              }}
            >
              <DownloadIcon className='me-1' /> {t('Download')}
            </Button>
          </div>
          <div className='col'>
            {sent ? (
              <div className='TaxAdvisorDatev__btn Button--outline d-flex align-items-center'>
                <TipIcon className='me-1' /> {t('Pushed to DATEV')}
              </div>
            ) : (
              <Button
                styling='outline'
                className='TaxAdvisorDatev__btn d-flex align-items-center'
              >
                <SendIcon className='me-1' /> {t('Push to DATEV')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
